/**
 * Default toolbar items for rich-text fields.
 * Engine-agnostic — imported by tiptap-engine.js and crud-page.js.
 * @type {import('../../contracts/forms.js').RichTextToolbarItem[]}
 */
export const DEFAULT_RICH_TEXT_TOOLBAR = [
  'bold', 'italic', 'color', 'heading', 'blockquote', 'sourceView',
  'alignLeft', 'alignCenter', 'alignRight',
  'bulletList', 'orderedList', 'link', 'image', 'youtube', 'table',
];
